import React from 'react'
import { useSelector } from 'react-redux';

import { 
    Grid,
    makeStyles,
} from "@material-ui/core";

import { MENU_TIPO_EXPEDIENTE } from '../../../utils/constants';
import { ConsultaComprobantes } from '../UI/ConsultaComprobantes';
import { ComprobantesPrestadores } from './ComprobantesPrestadores';
import { ComprobantesDocumentos } from './ComprobantesDocumentos';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
}));

export const MesaEntradaRecepcion = () => {
    const classes = useStyles();
    const { recepcionMenu } = useSelector(state => state.mesaEntrada);
    const { dataContrato } = useSelector((state) => state.contrataciones);

    return (
    <div className={classes.root}>
        <Grid
            container
            spacing={1}
            direction="row"
            justify="center"
            alignItems="center"
        >   
            <Grid item xs={12} className={classes.center}>
                <ConsultaComprobantes />
            </Grid>
            <Grid item xs={12} className={classes.center}>
                {recepcionMenu === MENU_TIPO_EXPEDIENTE.PRESTADOR && dataContrato && <ComprobantesPrestadores />}
            </Grid>
            <Grid item xs={12} className={classes.center}>
                {recepcionMenu === MENU_TIPO_EXPEDIENTE.DOCUMENTO && <ComprobantesDocumentos />}
            </Grid>
        </Grid>
    </div>
  )
}
